import React, { useEffect, useState } from "react";
import Header from "../components/ui/header/Header";

export default function PrimaryLayout({ children, isOpen, setOpen }) {
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setIsHeaderFixed(
        currentScrollPos < prevScrollPos && currentScrollPos > 0
      );
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);
  console.log("isHeaderFixed", isHeaderFixed);
  return (
    <div className=" relative overflow-x-hidden">
      

      <div
        className={`w-full z-999 top-0  ${
          isHeaderFixed
            ? "fixed bg-[#35373A] fadeInDown"
            : "absolute bg-transparent"
        }`}
      >
        <Header
          isOpen={isOpen}
          setOpen={setOpen}
          type="primary"
          isHeaderFixed={isHeaderFixed}
        />
      </div>
      <div>{children}</div>
     
    </div>
  );
}
